import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 455 455",
  "content": "<symbol viewBox=\"0 0 455 455\" id=\"icon-add\"><path fill=\"currentColor\" d=\"M455 212.5H242.5V0h-30v212.5H0v30h212.5V455h30V242.5H455z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/add.svg
// module id = 249
// module chunks = 2